
export default {
  methods: {
    close() {
      this.$emit('close')
    }
  }
}
